<template>
    <div class="col-12 d-flex dashboard">
        <div class="w-100">
            <div class="row">
                <ArtistValue :artistsValue="allData.financeData.artist_value" />
                <UserValue :userValue="allData.financeData.user_value" />
                <VenueValue :venueValue="allData.financeData.venue_value" />
            </div>
        </div>
    </div>
</template>

<script>
import ArtistValue from './ArtistValue.vue'
import UserValue from './UserValue.vue'
import VenueValue from './VenueValue.vue'

export default {
    name: 'FinanceDashboard',
    components: {
        ArtistValue,
        UserValue,
        VenueValue
    },
    data: () => ({
        url: '/admin/dashboard/getFinanceMarketing',
        allData: []
    }),
    async created() {
       const res = await axios.get(this.url)
       this.allData = res.data
    }
}
</script>
